<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5253 3.35991C17.7694 3.11583 17.7694 2.7201 17.5253 2.47603C17.2812 2.23195 16.8855 2.23195 16.6414 2.47603L17.0833 2.91797L17.5253 3.35991ZM10.8081 8.30936C10.564 8.55344 10.564 8.94917 10.8081 9.19324C11.0521 9.43732 11.4479 9.43732 11.6919 9.19324L11.25 8.7513L10.8081 8.30936ZM11.25 8.7513L11.6919 9.19324L17.5253 3.35991L17.0833 2.91797L16.6414 2.47603L10.8081 8.30936L11.25 8.7513Z"
      fill="currentcolor"
    />
    <path
      d="M2.47603 16.6414C2.23195 16.8855 2.23195 17.2812 2.47603 17.5253C2.7201 17.7694 3.11583 17.7694 3.35991 17.5253L2.91797 17.0833L2.47603 16.6414ZM9.19324 11.6919C9.43732 11.4479 9.43732 11.0521 9.19324 10.8081C8.94917 10.564 8.55344 10.564 8.30936 10.8081L8.7513 11.25L9.19324 11.6919ZM2.91797 17.0833L3.35991 17.5253L9.19324 11.6919L8.7513 11.25L8.30936 10.8081L2.47603 16.6414L2.91797 17.0833Z"
      fill="currentcolor"
    />
    <path
      d="M13.75 2.72184C14.4537 2.71184 16.7841 2.22774 17.2782 2.72184C17.7723 3.21594 17.2882 5.54632 17.2782 6.25"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.25"
    />
    <path
      d="M2.72184 13.75C2.71184 14.4537 2.22774 16.7841 2.72184 17.2782C3.21594 17.7723 5.54632 17.2882 6.25 17.2782"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.25"
    />
  </svg>
</template>
